import { ORDER_STATES } from '../../helpers/constants'
import { OrderState } from '../../model'

const OrderStateLabel = (props: { state: OrderState | undefined }) => {
    const { state: currentState } = props
    const states = ORDER_STATES
    const stateConfig = states.find((p) => p.value === currentState)
    return <span className='text-xs block font-medium pt-1'>{stateConfig?.label}</span>
}

export default OrderStateLabel
